import * as React from 'react';
import { ErrorType, styled } from '@workday/canvas-kit-react/common';
import { space } from '@workday/canvas-kit-react/tokens';
import { Subtext, Text } from '@workday/canvas-kit-react/text';
const Message = styled(Subtext)(({ error, theme }) => error === ErrorType.Error && { color: theme.canvas.palette.error.main });
class Hint extends React.Component {
    render() {
        const { errorLabel = 'Error', alertLabel = 'Alert', children, error } = this.props;
        let hintLabel;
        switch (error) {
            case Hint.ErrorType.Error:
                hintLabel = errorLabel;
                break;
            case Hint.ErrorType.Alert:
                hintLabel = alertLabel;
                break;
            default:
        }
        return (React.createElement(Message, Object.assign({ size: "medium", margin: `${space.xxs} 0 0`, width: "100%" }, this.props),
            typeof error !== 'undefined' && hintLabel && (React.createElement(Text, { fontWeight: "medium" },
                hintLabel,
                ": ")),
            children));
    }
}
Hint.ErrorType = ErrorType;
Hint.ErrorType = ErrorType;
export { Hint };
